import store from "@/store";
import { getFinancialList } from '../../api/backoffice';

let financialNameById = {
    2: "BBVA",
    4: "Santander Consumer",
    6: "BPI",
    7: "CGD",
    8: "Cetelem",
    9: "Credibom",
    12: "BBVA ES",
    13: "Sofinco",
    15: "CaixaBank",
    16: "Cetelem ES",
    17: "Sabadell",
    18: "Santander Consumer ES",
};

/**
 * Carrega dinamicamente a lista de financeiras e atualiza o mapeamento
 * @returns {Promise<Object>} Objeto mapeado com ID como chave e nome como valor
 */
async function loadFinancialNames() {
    try {
        const idInstance = store.getters["AuthenticationModule/getUserInstanceId"] || -1;
        const response = await getFinancialList(idInstance);
        
        if (response?.data && Array.isArray(response.data?.data)) {
            financialNameById = response.data?.data.reduce((acc, financial) => {
                acc[financial.ID] = financial.NAME;
                return acc;
            }, {});
        }
    
        return financialNameById;
    } catch (error) {
        console.error('Erro ao carregar lista de financeiras:', error);
        return financialNameById; // Retorna o objeto estático em caso de erro
    }
}

/**
 * Obtém o nome da financeira pelo ID
 * @param {number} id - ID da financeira
 * @returns {string|undefined} Nome da financeira ou undefined se não encontrado
 */
function getFinancialName(id) {
    return financialNameById[id];
}

export { 
    financialNameById, 
    loadFinancialNames, 
    getFinancialName 
}